var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"color":_vm.color,"icon":"fas fa-concierge-bell","title":"Success inbound chats","percent":_vm.percent,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }